import { Injectable } from '@angular/core';
import { Consorcio } from '../model/Consorcio';
import { Sucursal } from '../model/sucursal';
import { DocumentoDetalleEntrada } from '../model/documento-detalle-entrada';
import { DocumentoEntrada } from '../model/documento-entrada';
import { Excepcion } from '../model/excepcion';

import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service';
import { Resultado } from 'app/model/resultado';
@Injectable()
export class DocumentoDetalleEntradaService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }

  getDetalle(documento: DocumentoEntrada): Observable<DocumentoDetalleEntrada[]> {

    let json = { "Metodo": "findDetalleDocumentoEntrada", "Datos": documento };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    return this._http.post(this._utilities.getURL("get"),
      params, { headers: headers }).map(res => res.json());

  }

  // getDetalleByDocumento(query: any): Observable<DocumentoDetalleEntrada[]> {

  //   let json = { "Metodo": "findDetalleDocumentoEntradaByDocument", "Datos": query };

  //   let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
  //   let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

  //   return this._http.post(this._utilities.getURL("post"),
  //     params, { headers: headers }).map(res => res.json());

  // }

  getDetalleByDocumento(codigoConsorcio: string, codigoDocumento: string): Observable<DocumentoDetalleEntrada[]> {

    const requestUrl = this._utilities.getURLIIS('DocumentoEntrada/entradaDetalle/'
    + codigoConsorcio + '/' + codigoDocumento + '/');

  return this._http.get(requestUrl).map((response: Response) => {
    return <DocumentoDetalleEntrada[]>response.json();
  });

  }


  // public insert(detalle: DocumentoDetalleEntrada) {

  //   let json = { "Metodo": "postDetalleDocumentoEntrada", "Datos": detalle };

  //   let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
  //   let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

  //   return this._http.post(this._utilities.getURL("post"),
  //     params, { headers: headers }).map(res => res.json());
  // }

  public insert(detalle: DocumentoDetalleEntrada[]): Observable<Resultado> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let url = this._utilities.getURLIIS("DocumentoEntrada/postDocumentoDetalleEntrada/");

    let params = JSON.stringify(detalle);

    return this._http.post(url, detalle, { headers: headers }).map(res => res.json());
  }

  public delete(detalle: DocumentoDetalleEntrada) {

    let json = { "Metodo": "deleteDetalleDocumentoEntrada", "Datos": detalle };

    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });


    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
  }

  public deleteAll(cabecera: DocumentoEntrada) {

    let json = { "Metodo": "deleteAllDetalleDocumentoEntrada", "Datos": cabecera };
    let params = "Data=" + this._utilities.getEscapeString(JSON.stringify(json));
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this._http.post(this._utilities.getURL("post"),
      params, { headers: headers }).map(res => res.json());
      
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/documento-detalle-entrada.service.ts